<div class="root" *ngIf="loading">
  <div class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></div>
</div>
